export const NON_EXISTENT_PARENT_COMMENT_ID = 0
export const ACCESS_CONDITION_PUBLIC = 'PUBLIC'
export const SEGMENTED_ARTICLE_EXPERIMENT_IDS = [1796026125, 2552559416, 2488519687]
export const PLACEHOLDER_BANNER_NAME = 'data-orientation-banner'
export const WHATSAPP_URL_WITH_TEXT =
  'https://wa.me/5511918999148?text=Ol%C3%A1%2C%20tenho%20d%C3%BAvidas%20sobre%20os%20meus%20direitos'
export const WHATSAPP_URL_WITH_NO_TEXT = 'https://wa.me/5511918999148?text='

export const WHATSAPP_URL_WITH_TEXT_ARTIGOS =
  'https://wa.me/5511918999148?text=Olá! Acabei de ler um artigo no Jusbrasil e queria entender quais são os meus direitos.'
export const WHATSAPP_URL_WITH_TEXT_NOTICIAS =
  'https://wa.me/5511918999148?text=Olá! Acabei de ler uma notícia no Jusbrasil e queria saber se algo parecido pode se aplicar ao meu caso.'
